import { withStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { IconButton, SnackbarContent } from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import amber from '@material-ui/core/colors/amber';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/Warning'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'

const styles = (theme: any) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.dark,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  spacing: {
    marginRight: 8,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
});


const ValidationSnackbarContentWrapper = (props: any) => {
  const { classes, className, message, onClose, variant, ...other } = props;
  return (
    <SnackbarContent
      className={[classes[variant], className].join(' ')}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message} style={{whiteSpace: 'pre'}}>
          {variant === 'success' &&
            <CheckCircleIcon className={[classes.icon, classes.spacing].join(' ')} />
          }
          {variant === 'warning' &&
            <WarningIcon className={[classes.icon, classes.spacing].join(' ')} />
          }
          {variant === 'error' &&
            <ErrorIcon className={[classes.icon, classes.spacing].join(' ')} />
          }
          {variant === 'info' &&
            <InfoIcon className={[classes.icon, classes.spacing].join(' ')} />
          }
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  )
}

export default withStyles(styles)(ValidationSnackbarContentWrapper);


// WEBPACK FOOTER //
// ./src/modules/shared/components/ValidationSnackbarContentWrapper.tsx